import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchPlannerTasks = createAsyncThunk(
  'plannerTasks/fetchTasks',
  async ({ jobNumber }, { signal, rejectWithValue }) => {
    try {
      const res = await fetch(
        `${API_URL}/api/planner/tasks?jobNumber=${encodeURIComponent(jobNumber)}`,
        { signal }
      );
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json?.message || 'Failed to fetch planner tasks');
      if (!json?.success) throw new Error(json?.message || 'Failed to fetch planner tasks');
      return json?.data || {};
    } catch (e) {
      if (e?.name === 'AbortError') throw e;
      console.error('plannerTasks/fetchTasks failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch planner tasks');
    }
  }
);

const initialState = {
  tasks: {
    overdue: [],
    thisWeek: [],
    nextWeek: [],
  },
  tasksLoading: false,
  tasksError: null,
};

const plannerTasksSlice = createSlice({
  name: 'plannerTasks',
  initialState,
  reducers: {
    clearPlannerTasks: (state) => {
      state.tasks = initialState.tasks;
      state.tasksLoading = false;
      state.tasksError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlannerTasks.pending, (state) => {
        state.tasksLoading = true;
        state.tasksError = null;
      })
      .addCase(fetchPlannerTasks.fulfilled, (state, action) => {
        state.tasksLoading = false;
        const data = action.payload || {};
        // Handle both old and new API response formats
        // New format: direct arrays, old format: nested in data object
        const tasksData = data.data || data;
        state.tasks = {
          overdue: Array.isArray(tasksData.overdue) ? tasksData.overdue : [],
          thisWeek: Array.isArray(tasksData.thisWeek) ? tasksData.thisWeek : [],
          nextWeek: Array.isArray(tasksData.nextWeek) ? tasksData.nextWeek : [],
        };
      })
      .addCase(fetchPlannerTasks.rejected, (state, action) => {
        state.tasksLoading = false;
        if (action?.meta?.aborted || action?.error?.name === 'AbortError') return;
        state.tasksError = action.payload || action.error?.message || 'Failed to fetch planner tasks';
      });
  },
});

export const { clearPlannerTasks } = plannerTasksSlice.actions;
export default plannerTasksSlice.reducer;
